import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class FeladatCsoportDto extends IdentifiableDto {
	constructor() {
		super();

		this.nev = null;
		this.rovid = null;
	}

	setup(props) {
		super.setup(props);

		this.nev = props.nev;
		this.rovid = props.rovid;

		return this;
	}
}

export default FeladatCsoportDto;